import type { ReactElement } from 'react';

import { Box, Button, Tooltip } from '@chakra-ui/react';

interface SectionActionProps {
  label: string;
  icon?: ReactElement;
  variant?: string;
  onClick?: () => void;
}

const SectionAction = ({
  label,
  icon,
  variant = 'brand',
  onClick,
}: SectionActionProps) => {
  return (
    <Tooltip label="Coming soon" placement="bottom" hasArrow>
      <Box flexShrink={0}>
        <Button
          size="sm"
          variant={variant}
          leftIcon={icon}
          onClick={onClick}
          isDisabled
        >
          {label}
        </Button>
      </Box>
    </Tooltip>
  );
};

export default SectionAction;
